// Canonical normalized department-name variants, kept in one place so every
// frontend check recognizes exactly the same spellings the backend does
// (backend/src/controllers/OMDashboardController.js for O&M). Before this,
// each of Navbar.js, ExcoLandingPage.js, UsersPage.js and
// DepartmentDashboardsPage.js carried its own hand-picked subset (1 to 4
// variants) — harmless only because the real department is literally named
// "O&M", which every subset happens to normalize-match.
export const OM_DEPARTMENT_NAME_KEYS = ['om', 'onm', 'oandm', 'operationsmaintenance', 'operationmaintenance'];

export const isOmDepartmentKey = (key) => OM_DEPARTMENT_NAME_KEYS.includes(key);

export const HR_DEPARTMENT_NAME_KEYS = ['hr', 'humanresource', 'humanresources'];

export const isHrDepartmentKey = (key) => HR_DEPARTMENT_NAME_KEYS.includes(key);
